import { useState, useEffect } from "react";
import "../../assets/css/Login/Login.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { Navigate, Link } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
import LoginPassword from "../LoginPassword/LoginPassword";
import LoginOtp from "../LoginOtp/LoginOtp";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../store/config";


function Login() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("password");

  const { instance } = useMsal();

  const microsoftLogin = async () => {
  try {
    const loginResponse = await instance.loginPopup({
      scopes: [
        "User.Read",
        "api://16daee4d-4bc2-41e0-808c-8d639812b144/api.read",
      ],
      prompt: "select_account",
    });

    const account = loginResponse.account;

    // 🔹 GRAPH TOKEN
    let graphAccessToken;
    try {
      const res = await instance.acquireTokenSilent({
        account,
        scopes: ["User.Read"],
      });
      graphAccessToken = res.accessToken;
    } catch {
      const res = await instance.acquireTokenPopup({
        account,
        scopes: ["User.Read"],
      });
      graphAccessToken = res.accessToken;
    }

    // 🔹 BACKEND TOKEN
    let backendToken;
    try {
      const res = await instance.acquireTokenSilent({
        account,
        scopes: ["api://16daee4d-4bc2-41e0-808c-8d639812b144/api.read"],
      });
      backendToken = res.accessToken;
    } catch {
      const res = await instance.acquireTokenPopup({
        account,
        scopes: ["api://16daee4d-4bc2-41e0-808c-8d639812b144/api.read"],
      });
      backendToken = res.accessToken;
    }

    // 🔹 BACKEND AUTH
    const res = await fetch(`${BASE_URL}api/auth/microsoft`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${backendToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.detail || "Backend auth failed");
    }

    const data = await res.json();

    // 🔹 STORE TOKENS
    localStorage.setItem("access_token", data.access_token);
    localStorage.setItem("ms_access_token", graphAccessToken);
    navigate("/dashboard");
  } catch (err) {
    console.error("Microsoft login error:", err);
    alert(err.message || "Login failed");
  }
};

  /* Google Login */

  const googleLogin = useGoogleLogin({
    scope: "openid profile email",
    onSuccess: async (tokenResponse) => {
      try {
        // 1️⃣ Fetch user info from Google
        const res = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
          },
        );
        const profileData = await res.json();

        // 2️⃣ Save user info + Google access token to localStorage
        localStorage.setItem(
          "google_user",
          JSON.stringify({
            name: profileData.name,
            email: profileData.email,
            picture: profileData.picture,
            access_token: tokenResponse.access_token,
          }),
        );

        // 3️⃣ Send Google token to your backend (optional)
        const backendRes = await fetch(`${BASE_URL}api/auth/google`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token: tokenResponse.access_token }),
        });

        const backendData = await backendRes.json();
        // Save backend JWT separately
        localStorage.setItem("access_token", backendData.access_token);
        localStorage.setItem(
          "first_time_user",
          backendData.is_first_user ? "True" : "False",
        );

        // 4️⃣ Redirect to welcome page using React Router
        navigate("/dashboard");
      } catch (error) {
        console.error("Google login error", error);
        alert("Login failed");
      }
    },
    onError: () => alert("Google login failed"),
  });

  // if (isAuthenticated) {
  //   return <Navigate to="/welcome" replace />;
  // }

  // useEffect(() => {
  //   localStorage.clear();
  //   sessionStorage.clear();
  // }, []);

  return (
    <>
      <Header showProfile={false} />

      <div className="login_container">
        <div className="card_login_card">
          <div className="login-title">
            <h2>Log in to your account</h2>
            <p>Choose how you want to log in</p>
          </div>

          {/* 🔹 LOGIN TABS */}
          <div className="card-header">
            <ul className="nav nav-tabs card-header-tabs">
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "password" ? "active" : ""
                    }`}
                  onClick={() => setActiveTab("password")}
                >
                  Email + Password
                </button>
              </li>

              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "otp" ? "active" : ""}`}
                  onClick={() => setActiveTab("otp")}
                >
                  Email + OTP
                </button>
              </li>
            </ul>
          </div>

          {/* 🔹 TAB CONTENT */}
          <div className="card-body">
            {activeTab === "password" && <LoginPassword />}
            {activeTab === "otp" && <LoginOtp />}

            <div className="divider">Other login options</div>

            <div className="social">
              <button onClick={googleLogin} data-testid="google-btn">
                <img
                  src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/google/google-original.svg"
                  alt=""
                />
              </button>

              <button onClick={microsoftLogin} data-testid="microsoft-btn">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
                  alt=""
                />
              </button>
            </div>



            {/* ✅ MOVE THIS HERE */}
            <div className="signup-text">
              Don't have an account? <Link to="/signup">Sign up</Link>
            </div>

          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Login;
